module.exports = __webpack_public_path__ + "static/media/sign-out-icon.63025083.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/sign-out-icon.png
// module id = 541
// module chunks = 0